/**
 * @file INCSUBButton.js
 * @description A customizable button component for rendering a button with various styles, an optional loader, and an icon.
 * This button supports dynamic styling, click handling, and optional loading states.
 */

import React from 'react';
import './INCSUBButton.css';

function INCSUBButton({
  text = '',                    // Button text, default is empty string
  color = 'rgba(255, 255, 255, 1)', // Text color, default is white
  background = 'rgba(72, 128, 255, 1)', // Background color, default is blue
  border = null,                // Button border style (e.g., '1px solid #ccc'), default is no border
  clickFun = null,              // Function to call on button click, default is no function
  icon = null,                  // Optional icon to display next to the text
  marginRight = null,           // Optional right margin for spacing, default is no margin
  borderRadius = null,          // Optional border-radius for rounded corners
  cursor = null,                // Optional cursor style, default is no custom cursor
  isBtnLoader = false           // If true, show a loading spinner instead of the button text
}) {

  return (
    <div
      className='INCSUBcommonBtn'
      style={{
        backgroundColor: `${background}`,  // Button background color
        color: `${color}`,                  // Button text color
        marginRight: marginRight,           // Optional right margin
        border: border,                    // Optional border style
        borderRadius: borderRadius,        // Optional border-radius
        cursor: cursor                     // Optional cursor style
      }}
    >
      {!isBtnLoader ? (
        // If not loading, render the button
        <button
          style={{ cursor: cursor }}   // Apply the cursor style on the button
          onClick={() => {
            if (clickFun !== null) {   // If a click handler is provided
              clickFun(text);          // Pass button text to the click handler
            }
          }}
        >
          {icon}{text}                  {/* Display the icon (if any) and text */}
        </button>
      ) : (
        // If loading, display a loading spinner
        <div className='btnLoader' />
      )}
    </div>
  );
}

export default INCSUBButton;
